/* eslint-disable import/no-anonymous-default-export */
import { SET_SETTINGS_OPEN } from '../actionConstants';

export default (state = false, action) => {
  switch (action.type) {
    case SET_SETTINGS_OPEN:
      return action.payload;
    default:
      return state;
  }
};
